<template>
    <v-row dense align="center" align-content="center" justify="center">
        <v-col cols="12">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">                            
                    <v-row dense align="center" align-content="center" justify="center">
                        <v-col cols="4">
                            <span class="title ml-3"> Meu Link Quoon </span> <br/>
                            <span class="body-2 ml-3"> O link para acesso ao seu catálogo está <span :class="(quoonlink)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonlink)?'Ativo':'Inativo'}}</span>   </span>                                
                        </v-col>
                        <v-col cols="6">
                            <v-row align="center" align-content="center" justify="center">
                                <v-col cols="5" class="text-right">
                                    <span class="title"> https://www.quoon.app/ </span>
                                </v-col>
                                <v-col cols="3" class="pl-0">
                                    <v-form ref="url">
                                        <v-text-field :rules="[rules.urlValidate]" v-model="url" solo dense outlined hide-details></v-text-field>
                                    </v-form>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn color="primary" fab small dark @click="saveConfig('url',url)">
                                        <v-icon>mdi-content-save</v-icon>
                                    </v-btn>                                                   
                                    <v-btn color="primary" class="ml-1" fab small dark>
                                        <v-icon>mdi-content-copy</v-icon>
                                    </v-btn>                                                                               
                                </v-col>
                                <v-spacer></v-spacer>
                            </v-row>                                    
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                            <v-switch v-model="quoonlink" :label="(quoonlink)?'Ativo':'Inativo'" :color="(quoonlink)?'green':'red'" @change="saveConfig('quoonlink',quoonlink)">
                            </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>   
        </v-col>  
        <v-col cols="12">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">                            
                    <v-row dense align="center" align-content="center" justify="center">
                        <v-col cols="4">
                            <span class="title ml-3"> Meu WhatsApp </span> <br/>
                            <span class="body-2 ml-3"> O recebimento de Pedidos via Whatsapp está <span :class="(getwhatsapp)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(getwhatsapp)?'Ativo':'Inativo'}}</span>   </span>                                
                        </v-col>
                        <v-col cols="6">
                            <v-row align="center" align-content="center" justify="center">
                                <v-col cols="4" class="text-right">
                                    <v-btn color="green" class="ml-1" fab small dark>
                                        <v-icon>mdi-whatsapp</v-icon>
                                    </v-btn>                                                                                 
                                </v-col>                                            
                                <v-col cols="1" class="text-right pl-0">
                                    <span class="title"> + 55 </span>
                                </v-col>
                                <v-col cols="3" class="pl-0">
                                    <v-text-field v-model="whatsapp" type="number" solo dense outlined hide-details ></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn color="primary" fab small dark @click="saveConfig('whatsapp',whatsapp)">
                                        <v-icon>mdi-content-save</v-icon>
                                    </v-btn>                                                                                 
                                </v-col>
                                <v-spacer></v-spacer>
                            </v-row>                                    
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                            <v-switch v-model="getwhatsapp" :label="(getwhatsapp)?'Ativo':'Inativo'" :color="(getwhatsapp)?'green':'red'" @change="saveConfig('getwhatsapp',getwhatsapp)">
                            </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>   
        </v-col>                    
        <v-col cols="12">  
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">
                    <v-row dense>
                        <v-col cols="4">
                            <span class="title ml-3"> Horário de Atendimento </span> <br/>
                            <span class="subtitle ml-3"> Selecione os dias e horários de atendimento  </span> 
                        </v-col>
                        <v-col cols="8">
                            <timeView :title="'Segunda-Feira'" :abrev="'seg'" :valor="this.horarios.seg" v-on:loadMessage="loadMessage"/>
                            <timeView :title="'Terça-Feira'" :abrev="'ter'"  :valor="this.horarios.ter" v-on:loadMessage="loadMessage"/>
                            <timeView :title="'Quarta-Feira'" :abrev="'qua'" :valor="this.horarios.qua" v-on:loadMessage="loadMessage"/>
                            <timeView :title="'Quinta-Feira'" :abrev="'qui'" :valor="this.horarios.qui" v-on:loadMessage="loadMessage"/>
                            <timeView :title="'Sexta-Feira'" :abrev="'sex'" :valor="this.horarios.sex" v-on:loadMessage="loadMessage"/>
                            <timeView :title="'Sábado'" :abrev="'sab'" :valor="this.horarios.sab" v-on:loadMessage="loadMessage"/>
                            <timeView :title="'Domingo'" :abrev="'dom'" :valor="this.horarios.dom" v-on:loadMessage="loadMessage"/>
                            <timeView :title="'Feriados'" :abrev="'fer'" :valor="this.horarios.fer" v-on:loadMessage="loadMessage"/>
                        </v-col>        
                    </v-row>
                </v-card-text>
            </v-card>   
        </v-col>  
        <v-col cols="6">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">
                    <v-row dense align="center" align-content="center" justify="center">
                        <v-col cols="7">
                            <span class="title"> Selecione a coleção Ativa </span> <br/>
                            <span class="body-2"> A coleção ativa ficará visível para os seus usuários </span>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="4">
                            <selectCollection v-model="colecaoAtiva" :multiple="false" @collectionSelect="colecaoAtiva = $event" />
                        </v-col>  
                        <v-col cols="1">
                            <v-btn color="primary" fab small dark @click="saveConfig('colecao',colecaoAtiva)">
                                <v-icon>mdi-content-save</v-icon>
                            </v-btn>                                                                                                                                
                        </v-col>                                                                              
                    </v-row>
                </v-card-text>
            </v-card>                        
        </v-col>  
        <v-col cols="6">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">
                    <v-row dense align="center" align-content="center" justify="center">
                    <v-col cols="9">
                        <span class="title"> Habilitar Observações no Pedido? </span> <br/>
                        <span class="body-2"> A opção do cliente inserir observações no momento da Realização do Pedido está <span :class="(getObs)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(getObs)?'Ativa':'Inativa'}}</span>   </span>                                
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="3">
                        <v-switch v-model="getObs" :label="(getObs)?'Ativa':'Inativa'" :color="(getObs)?'green':'red'" @change="saveConfig('getObs',getObs)">
                        </v-switch>
                    </v-col>                                                            
                    </v-row>
                </v-card-text>
            </v-card>                        
        </v-col> 
        <v-col cols="6">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">
                    <v-row dense align="center" align-content="center" justify="center">
                    <v-col cols="9">
                        <span class="title"> Solicitar CPF na Nota? </span> <br/>
                        <span class="body-2"> A opção de Inserir CPF na Nota Fiscal está <span :class="(getcpf)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(getcpf)?'Ativa':'Inativa'}}</span>   </span>                                
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="3">
                        <v-switch v-model="getcpf" :label="(getcpf)?'Ativa':'Inativa'" :color="(getcpf)?'green':'red'" @change="saveConfig('getcpf',getcpf)">
                        </v-switch>
                    </v-col>                                                            
                    </v-row>
                </v-card-text>
            </v-card>                        
        </v-col>     
        <v-col cols="6">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">
                    <v-row dense align="center" align-content="center" justify="center">
                    <v-col cols="6">
                        <span class="title"> O Pedido poderá ser Trocado? </span> <br/>
                        <span class="body-2"> A opção de troca do produto está <span :class="(getTroca)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(getTroca)?'Ativa':'Inativa'}}</span>   </span>                                
                    </v-col>                         
                    <v-col cols="2" class="text-center">
                        <v-text-field v-model="prazoTroca" type="number" hint="Defina o Prazo de Troca (em Dias)" min="0" ></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <v-btn color="primary" fab small dark @click="saveConfig('prazoTroca',prazoTroca)">
                            <v-icon>mdi-content-save</v-icon>
                        </v-btn>  
                    </v-col>                                 
                    <v-spacer></v-spacer>
                    <v-col cols="3">
                        <v-switch v-model="getTroca" :label="(getTroca)?'Ativa':'Inativa'" :color="(getTroca)?'green':'red'" @change="saveConfig('getTroca',getTroca)">
                        </v-switch>
                    </v-col>                                                            
                    </v-row>
                </v-card-text>
            </v-card>                        
        </v-col>      
        <v-col cols="12">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">
                    <v-row dense align="center" align-content="center" justify="center">
                    <v-col cols="5">
                        <span class="title"> Permitir pedidos fora do Horário de Funcionamento? </span> <br/>
                        <span class="body-2"> A opção de pedidos fora do horário está <span :class="(getOutData)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(getOutData)?'Ativa':'Inativa'}}</span>   </span>                                
                    </v-col>                         
                    <v-col cols="4" class="text-center">
                        <v-textarea v-model="messageOut" :rules="[rules.maxlength(100)]" hint="Digite a mensagem que será entregue ao cliente" rows="2" counter="100" ></v-textarea>
                    </v-col>
                    <v-col cols="1">
                        <v-btn color="primary" fab small dark @click="saveConfig('messageOut',messageOut)">
                            <v-icon>mdi-content-save</v-icon>
                        </v-btn>  
                    </v-col>                                 
                    <v-spacer></v-spacer>
                    <v-col cols="2">
                        <v-switch v-model="getOutData" :label="(getOutData)?'Ativa':'Inativa'" :color="(getOutData)?'green':'red'" @change="saveConfig('getOutData',getOutData)">
                        </v-switch>
                    </v-col>                                                            
                    </v-row>
                </v-card-text>
            </v-card>                        
        </v-col>                                                                                                                                                                                                                                                                                                                                                                  
    </v-row>    
</template>
<script>
import timeView from '@/components/general/timeComponent'
import {db} from '@/main'
import dbFunctions from "@/dbFunctions"
import store from "@/store"
import selectCollection from "@/modules/products/collection/FieldListCollection"

    export default {
        components: {timeView, selectCollection},
        data: () => ({
            rules: {
                required: value => !!value || 'Campo Obrigatório.',
                min: v => v.length >= 8 || 'Min 8 characters',
                minlength: len => v => (v || '').length >= len || `Número de Caractéres Inválido. Mínimo: ${len}`,
                maxlength: len => v => (v || '').length < len || `Número de Caractéres Inválido. Máximo: ${len}`,
                urlValidate: v => !/[^a-zA-Z0-9_-]+/.test(v) || 'E-mail must be e-core.com domain',                
            },            
            quoonlink: false,
            getwhatsapp: false,
            getOutData: false,
            getTroca: false,
            getcpf: false,
            getObs: false,
            messageOut: '',
            prazoTroca: 0,
            colecaoAtiva: '',
            attendTime: [],
            whatsapp: '',
            url: '',
            companyId: ''        
        }),
        created(){
            this.companyId = this.$store.getters.company.data.id
            this.getDataInfo = dbFunctions.getDataInfo
            this.getCompanyInfo = dbFunctions.getCompanyInfo
            
            this.quoonlink = this.$store.getters.company.data.configAtendimento.quoonlink
            this.getwhatsapp = this.$store.getters.company.data.configAtendimento.getwhatsapp
            this.getOutData = this.$store.getters.company.data.configAtendimento.getOutData
            this.getTroca = this.$store.getters.company.data.configAtendimento.getTroca
            this.getcpf = this.$store.getters.company.data.configAtendimento.getcpf
            this.getObs = this.$store.getters.company.data.configAtendimento.getObs
            this.horarios = this.$store.getters.company.data.horarios
        },
        methods: {
            saveConfig(item, value){
                if (item == 'url') {
                    if (!this.$refs.url.validate()){
                        let errorMessage = {
                            'active':true,
                            'color':'warning',
                            'message': 'Verifique a URL Digitada e Tente Novamente'
                        }          
                        this.$emit("loadMessage",errorMessage) 
                        return false
                    }
                }
                if (item == 'colecao'){
                    value = db.collection("colecoes").doc(value)
                }

                // console.log("Passou")
                let configAtendimento = this.$store.getters.company.data.configAtendimento || {}
                configAtendimento[item] = value
                configAtendimento = {
                    'configAtendimento': configAtendimento
                }

                db.collection('empresas').doc(this.companyId).update(configAtendimento).then(async() => {
                    this.loading = false
                    let success = {
                        'active':true,
                        'color':'success',
                        'message':'Configuração Atualizada com Sucesso'
                    }                
                    await this.reloadData(this.$store.getters.company.data.id)
                    this.$emit("loadMessage",success)
                    // this.$emit("listEdit")
                    // this.clearFields()
                }).catch(function (error) {
                    let errorMessage = {
                        'active':true,
                        'color':'error',
                        'message': error
                    }          
                    console.error('Error to Save Config - AttendPage: ' + error)
                    this.$emit("loadMessage",errorMessage)
                })                
            }, 
            async reloadData(companyId){
                let dataStore = await this.getDataInfo(companyId)
                let empresa = await this.getCompanyInfo(companyId)
              
                store.dispatch("fetchData",dataStore)
                store.dispatch("fetchCompany",empresa)   
            },  
            loadMessage(value){
                this.$emit("loadMessage", value);            
            }
        }        
    }
</script>